import * as React from 'react';
import { Fragment, useState } from 'react';

import { MenuItem, Stack, TextField, Typography } from '@mui/material';

import MuiRadioGroup from './MuiRadioGroup';
import { Grid, Box } from '@mui/material';

import Form from 'components/Form';
import { IFormRegister, IFormValues } from 'routes/Main/type';

import SectionTitle from '../components/SectionTitle';
import RowContainer from '../components/RowContainer';
import RowContent from '../components/RowContent';
import RowContentTwo from './components/RowContent';

interface Props extends IFormRegister, IFormValues {
  disabled?: boolean;
  dietList: string[];
  setDietList: (dietList: string[]) => void;
}

const checks = [
  {
    label: 'NPO  (Nothing per oral, 금식)',
    key: 'break_fast.default_diet.checked1',
  },
  {
    label: 'SOW (Sips of water, 소량의 물)',
    key: 'break_fast.default_diet.checked2',
  },
  {
    label: 'LD (Liquid diet, 유동식)',
    key: 'break_fast.default_diet.checked3',
  },
  {
    label: 'SD (Soft diet, 연식)',
    key: 'break_fast.default_diet.checked4',
  },
  {
    label: 'RD (Regular diet, 일반 상식)',
    key: 'break_fast.default_diet.checked5',
  },
  {
    label: 'TD (Tolerable Diet, 자유식)',
    key: 'break_fast.default_diet.checked6',
  },
  {
    label: 'NG (Naso Gastric, 위관 영양)',
    key: 'break_fast.default_diet.checked7',
  },
  {
    label: 'TPN (Total Parenteral Nutrition, 완전 비경구 영양)',
    key: 'break_fast.default_diet.checked8',
  },
];

const checks2 = [
  {
    label: '간경화식',
    key: 'break_fast.treatment.checked1',
  },
  {
    label: '간이식후식',
    key: 'break_fast.treatment.checked2',
  },
  {
    label: '갑상선기능저하증식',
    key: 'break_fast.treatment.checked3',
  },
  {
    label: '갑상선기능항진증식',
    key: 'break_fast.treatment.checked4',
  },
  {
    label: '갑상선암식',
    key: 'break_fast.treatment.checked5',
  },
  {
    label: '결핵식',
    key: 'break_fast.treatment.checked6',
  },
  {
    label: '고지혈증식',
    key: 'break_fast.treatment.checked7',
  },
  {
    label: '고혈압식',
    key: 'break_fast.treatment.checked8',
  },
  {
    label: '골다공증식',
    key: 'break_fast.treatment.checked9',
  },
  {
    label: '구루병식',
    key: 'break_fast.treatment.checked10',
  },
  {
    label: '급성/만성 위염식',
    key: 'break_fast.treatment.checked11',
  },
  {
    label: '급성골수백혈병식',
    key: 'break_fast.treatment.checked12',
  },
  {
    label: '급성신부전식',
    key: 'break_fast.treatment.checked13',
  },
  {
    label: '급성췌장염식',
    key: 'break_fast.treatment.checked14',
  },
  {
    label: '뇌경색식',
    key: 'break_fast.treatment.checked15',
  },
  {
    label: '뇌졸중식',
    key: 'break_fast.treatment.checked16',
  },
  {
    label: '다발성골수종식',
    key: 'break_fast.treatment.checked17',
  },
  {
    label: '당뇨병식',
    key: 'break_fast.treatment.checked18',
  },
  {
    label: '대사증후군식',
    key: 'break_fast.treatment.checked19',
  },
  {
    label: '대장암식',
    key: 'break_fast.treatment.checked20',
  },
  {
    label: '만성신부전식',
    key: 'break_fast.treatment.checked21',
  },
  {
    label: '만성폐쇄성폐질환식',
    key: 'break_fast.treatment.checked22',
  },
  {
    label: '말기신질환식',
    key: 'break_fast.treatment.checked23',
  },
  {
    label: '바이러스성 간염식',
    key: 'break_fast.treatment.checked24',
  },
  {
    label: '복수식',
    key: 'break_fast.treatment.checked25',
  },
  {
    label: '빈혈식',
    key: 'break_fast.treatment.checked26',
  },
  {
    label: '산모식',
    key: 'break_fast.treatment.checked27',
  },
  {
    label: '섭식장애식',
    key: 'break_fast.treatment.checked28',
  },
  {
    label: '심근경색식',
    key: 'break_fast.treatment.checked29',
  },
  {
    label: '알콜성간질환식',
    key: 'break_fast.treatment.checked30',
  },
  {
    label: '요로결석식',
    key: 'break_fast.treatment.checked31',
  },
  {
    label: '위식도역류질환식',
    key: 'break_fast.treatment.checked32',
  },
  {
    label: '위암식',
    key: 'break_fast.treatment.checked33',
  },
  {
    label: '임신성 당뇨식',
    key: 'break_fast.treatment.checked34',
  },
  {
    label: '임신성 고혈압식',
    key: 'break_fast.treatment.checked35',
  },
  {
    label: '장폐색식',
    key: 'break_fast.treatment.checked36',
  },
  {
    label: '저나트륨혈증식',
    key: 'break_fast.treatment.checked37',
  },
  {
    label: '저마그네슘혈증식',
    key: 'break_fast.treatment.checked38',
  },
  {
    label: '저칼륨식',
    key: 'break_fast.treatment.checked39',
  },
  {
    label: '저퓨린식',
    key: 'break_fast.treatment.checked40',
  },
  {
    label: '저혈당증식',
    key: 'break_fast.treatment.checked41',
  },
  {
    label: '저혈압식',
    key: 'break_fast.treatment.checked42',
  },
  {
    label: '허혈성심장질환식',
    key: 'break_fast.treatment.checked43',
  },
  {
    label: '협심증식',
    key: 'break_fast.treatment.checked44',
  },
];

const checks3 = [
  {
    label: '적은밥',
    key: 'break_fast.special.checked1',
  },
  {
    label: '모든 생선 제외',
    key: 'break_fast.special.checked2',
  },
  {
    label: '간장 추가',
    key: 'break_fast.special.checked3',
  },
  {
    label: '반찬 많이',
    key: 'break_fast.special.checked4',
  },
  {
    label: '진밥',
    key: 'break_fast.special.checked5',
  },
  {
    label: '등푸른 생선 제외',
    key: 'break_fast.special.checked6',
  },
  {
    label: '고추장 추가',
    key: 'break_fast.special.checked7',
  },
  {
    label: '김치 많이',
    key: 'break_fast.special.checked8',
  },
  {
    label: '된밥',
    key: 'break_fast.special.checked9',
  },
  {
    label: '해물 제외',
    key: 'break_fast.special.checked10',
  },
  {
    label: '고춧가루 추가',
    key: 'break_fast.special.checked11',
  },
  {
    label: '치아보조 (갈아서)',
    key: 'break_fast.special.checked12',
  },
  {
    label: '잡곡밥',
    key: 'break_fast.special.checked13',
  },
  {
    label: '계란 제외',
    key: 'break_fast.special.checked14',
  },
  {
    label: '소금 추가',
    key: 'break_fast.special.checked15',
  },
  {
    label: '치아보조 (다져서)',
    key: 'break_fast.special.checked16',
  },
  {
    label: '국 추가',
    key: 'break_fast.special.checked17',
  },
  {
    label: '모든 고기 제외',
    key: 'break_fast.special.checked18',
  },
  {
    label: '설탕 추가',
    key: 'break_fast.special.checked19',
  },
  {
    label: '서양식',
    key: 'break_fast.special.checked20',
  },
  {
    label: '국만 맵지 않게',
    key: 'break_fast.special.checked21',
  },
  {
    label: '돼지 고기 제외',
    key: 'break_fast.special.checked22',
  },
  {
    label: '모든 유제품 제외',
    key: 'break_fast.special.checked23',
  },
  {
    label: '이슬람 할랄식',
    key: 'break_fast.special.checked24',
  },
];

const DietSelection1 = (props: Props) => {
  const { disabled, register, getValues, setValue, dietList, setDietList } =
    props;

  const 적용급식1 = checks
    .filter((item, i) => getValues(item.key))
    .map(v => v.label);

  const 적용급식필터링1 = 적용급식1.join(', ');

  return (
    <>
      <SectionTitle title="조식" />

      <RowContainer xs={12}>
        <RowContent title="칼로리(Kcal)" titleRatio={1.3} childrenRatio={10.7}>
          <Stack direction="row" spacing={1}>
            <Form.MuiTextField
              required={false}
              fullWidth
              placeholder="필요 시 입력"
              InputProps={{ ...Form.adornment('', 'kcal') }}
              {...register('break_fast.calorie')}
            />
          </Stack>
        </RowContent>
        <RowContent
          title="식이 발행 (조식)"
          titleRatio={10.5}
          childrenRatio={1.5}
        >
          <Stack direction="row" spacing={1}>
            <Form.MuiCheckbox
              disabled={disabled}
              label={'보호자 식이'}
              defaultValue={
                Boolean(getValues('break_fast.guardian_meal'))
                  ? ['보호자 식이']
                  : []
              }
              onChange={(_, checked) => {
                setValue('break_fast.guardian_meal', checked);
              }}
            />
          </Stack>
        </RowContent>
        <RowContentTwo title="" titleRatio={0} childrenRatio={12}>
          <Form.MuiTextField
            fullWidth
            InputProps={{ readOnly: true }}
            placeholder={
              적용급식필터링1.length > 0 ? 적용급식필터링1 : '조식 목록'
            }
            multiline
            minRows={3}
          />
        </RowContentTwo>
      </RowContainer>
      <Box sx={{ width: '95%', margin: '30px auto 0px auto' }}>
        <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
          처방 식이
        </Typography>

        <Grid container xs={12}>
          {checks.map((v, i) => (
            <Grid item xs={3}>
              <Form.MuiCheckbox
                label={v.label}
                disabled={disabled}
                defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                onChange={(_, checked) => {
                  setValue(v.key, checked);
                  if (checked) setDietList([...dietList, v.label]);
                  else
                    setDietList([
                      ...dietList.filter(value => value !== v.label),
                    ]);
                }}
              />
            </Grid>
          ))}
        </Grid>

        <br />
        <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
          치료식
        </Typography>
        <Grid container xs={12}>
          {checks2.map((v, i) => (
            <Grid item xs={3}>
              <Form.MuiCheckbox
                label={v.label}
                disabled={disabled}
                defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                onChange={(_, checked) => {
                  setValue(v.key, checked);
                  if (checked) setDietList([...dietList, v.label]);
                  else
                    setDietList([
                      ...dietList.filter(value => value !== v.label),
                    ]);
                }}
              />
            </Grid>
          ))}
        </Grid>

        <br />
        <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>
          특이 사항
        </Typography>
        <Grid container xs={12}>
          {checks3.map((v, i) => (
            <Grid item xs={3}>
              <Form.MuiCheckbox
                label={v.label}
                disabled={disabled}
                defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                onChange={(_, checked) => {
                  setValue(v.key, checked);
                  if (checked) setDietList([...dietList, v.label]);
                  else
                    setDietList([
                      ...dietList.filter(value => value !== v.label),
                    ]);
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default DietSelection1;
